<template>
  <b-card>
    <b-card-header>
      <i class="icon-menu mr-1"></i>Import Group From CSV
    </b-card-header>
    <b-card-body>
      <div class="right">
        <a href="/asset/User_Batch_Registration_Form.csv">Download CSV Form File</a>
      </div>
      <GroupFromCsv/>
      <c-table v-show="$store.state.importResult.length > 0" :table-data="$store.state.importResult" :fields="fields" caption="Result"></c-table>
    </b-card-body>
  </b-card>
</template>

<script>
import Users from '../users/Users'
import GroupFromCsv from '../groups/GroupFromCsv'
import cTable from '../tables/Table'

export default {
  name: 'AddGroupWithUsers',
  components: {
      Users,
      GroupFromCsv,
      cTable
  },
  data: () => {
    return {
      fields: [
        {key: 'email', label: 'User', sortable: true},
        {key: 'result', sortable: true},
        {key: 'message', sortable: true}
      ],
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.right {
  text-align: end;
}
</style>